import React, { PropsWithChildren } from 'react'
import { notice } from '@shared/components/notice'
import PageAnimation from '@shared/components/page-animation'
import { formatPhone } from '@shared/utils/helpers'
import Image from 'next/image'

import { SignBrokerPageLayoutProps } from './model'

import styles from './style.module.scss'

const rulesUrl =
	'https://storage.yandexcloud.net/creditclub-frontend/static/docs/%D0%A4%D0%BE%D1%80%D0%BC%D0%B0%20%D0%B7%D0%B0%D1%8F%D0%B2%D0%BA%D0%B8/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0%20%D0%BF%D1%80%D0%B5%D0%B4%D0%BE%D1%81%D1%82%D0%B0%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D1%8F%20%D0%A1%D0%B5%D1%80%D0%B2%D0%B8%D1%81%D0%B0%20%D0%98%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%86%D0%B8%D0%BE%D0%BD%D0%BD%D0%B0%D1%8F%20%D1%81%D0%B8%D1%81%D1%82%D0%B5%D0%BC%D0%B0%20Credit.Club.pdf'

export const View = ({
	uiConfig: { params },
	children,
	hasError,
}: PropsWithChildren<SignBrokerPageLayoutProps>) => {
	if (hasError) {
		notice({
			title: 'Ошибка',
			message:
				'Для подписания документов необходимо включить Cookie в вашем браузере. Обратитесь к менеджеру, чтобы решить проблему.',
			type: 'error',
		})
	}

	return (
		<PageAnimation>
			<div className={styles.wrapper}>
				<header className={styles.header}>
					{params?.logoUri && (
						<Image
							className={styles.logo}
							alt={params.brokerOrgName ?? ''}
							src={params.logoUri}
						/>
					)}
					{params?.brokerOrgPhone && (
						<div className={styles.phone}>{formatPhone(params?.brokerOrgPhone)}</div>
					)}
				</header>
				<main className={styles.main}>{children}</main>
				<footer className={styles.footer}>
					<div className={styles.company}>
						© {new Date().getFullYear()} Информационная система Credit.Club
					</div>
					<a href={rulesUrl} target='_blank' rel='noopener noreferrer nofollow'>
						Правила предоставления сервиса
					</a>
				</footer>
			</div>
		</PageAnimation>
	)
}
